import React from "react";
import { Link as RouterLink } from "react-router-dom";
import zikoraLogo from "../images/ZikoraLogoGreen 1.png";

const inter = { fontFamily: "Inter, sans-serif" };

const NAV_COLUMNS = [
  {
    heading: "Products",
    links: [
      { label: "Loans", to: "/loans" },
      { label: "Savings", to: "/saving-account" },
      { label: "Z-ForHer", to: "/z-for-her" },
      { label: "Fixed Deposit", to: "/fixed-deposit" },
      { label: "Open Account", to: "/signup" },
      { label: "Download App", href: "https://onelink.to/zikora" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "Blog", to: "/blog" },
      { label: "FAQs", to: "/contact" },
      { label: "About Us", to: "/about" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy policy", to: "/privacy-policy" },
      { label: "Terms of Service", to: "/terms-service" },
      { label: "Banking Code", to: "/banking-code" },
    ],
  },
  {
    heading: "Contact",
    links: [
      { label: "Abatete, Anambra State" },
      { label: "+234 912 036 3787", href: "tel:+2349120363787" },
      { label: "+234 912 036 3788", href: "tel:+2349120363788" },
      { label: "info@zikoramfb.com", href: "mailto:info@zikoramfb.com" },
      {
        label: "customer.service@zikoramfb.com",
        href: "mailto:customer.service@zikoramfb.com",
      },
    ],
  },
];

const AppleIcon = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9 8.46c0-1.9 1.56-2.8 1.63-2.85-.88-1.29-2.25-1.47-2.74-1.49-1.18-.12-2.3.7-2.9.7-.6 0-1.52-.68-2.5-.66-1.28.02-2.47.75-3.13 1.9-1.33 2.3-.34 5.71.96 7.58.64.91 1.4 1.94 2.38 1.91.96-.04 1.32-.62 2.49-.62s1.49.62 2.5.6c1.02-.02 1.67-.93 2.3-1.86.72-1.06 1.02-2.08 1.04-2.14-.02-.01-1.98-.76-2.03-3.07z"
      fill="white"
    />
    <path
      d="M9.83 2.73c.53-.65.89-1.53.79-2.43-.77.03-1.69.51-2.24 1.14-.49.57-.92 1.49-.8 2.36.85.07 1.72-.44 2.25-1.07z"
      fill="white"
    />
  </svg>
);

const PlayIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.7 0.8L7.5 7 0.7 13.2V0.8z" fill="#EA4335" />
    <path
      d="M9.8 4.9L7.5 7l2.3 2.1 2.3-1.35c.64-.37.64-.99 0-1.36L9.8 4.9z"
      fill="#FBBC04"
    />
    <path d="M0.7 0.8L7.5 7 10 4.9 2.1.04A.78.78 0 00.7.8z" fill="#4285F4" />
    <path
      d="M0.7 13.2c.28.5.83.73 1.4.43L9.8 9.1 7.5 7 0.7 13.2z"
      fill="#34A853"
    />
  </svg>
);

const LinkedInIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 3.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM3.5 8h3v9h-3V8zM9 8h2.75v1.22C12.13 8.57 13 8 14.25 8 16.75 8 17.5 9.5 17.5 12v5h-3v-4.5c0-1.25-.5-2-1.5-2s-1.5.75-1.5 2V17H9V8z"
      fill="#032211"
    />
  </svg>
);

const TwitterIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 4.5a6.9 6.9 0 01-2 .55 3.5 3.5 0 001.53-1.93 6.95 6.95 0 01-2.21.84A3.49 3.49 0 0010 7.2c0 .27.03.54.09.8A9.9 9.9 0 012.8 4.13a3.49 3.49 0 001.08 4.66 3.47 3.47 0 01-1.58-.44v.04a3.49 3.49 0 002.8 3.42 3.5 3.5 0 01-1.58.06 3.49 3.49 0 003.26 2.42A7 7 0 012.5 15.5a9.9 9.9 0 005.36 1.57c6.44 0 9.96-5.33 9.96-9.96 0-.15 0-.3-.01-.45A7.12 7.12 0 0019.5 5l-2-.5z"
      fill="#032211"
    />
  </svg>
);

const InstagramIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="3"
      width="14"
      height="14"
      rx="4"
      stroke="#032211"
      strokeWidth="1.5"
    />
    <circle cx="10" cy="10" r="3" stroke="#032211" strokeWidth="1.5" />
    <circle cx="14.5" cy="5.5" r="1" fill="#032211" />
  </svg>
);

const FacebookIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 10a7 7 0 10-8.09 6.91v-4.9H7.08V10h1.83V8.42c0-1.81 1.08-2.81 2.73-2.81.79 0 1.62.14 1.62.14V7.5h-.91c-.9 0-1.18.56-1.18 1.13V10h2.01L12.71 12.02H11.2v4.9A7 7 0 0017 10z"
      fill="#032211"
    />
  </svg>
);

const SOCIALS = [
  {
    icon: <LinkedInIcon />,
    href: "https://www.linkedin.com/company/zikorabank",
    label: "LinkedIn",
  },
  {
    icon: <TwitterIcon />,
    href: "https://twitter.com/zikorabank",
    label: "Twitter",
  },
  {
    icon: <InstagramIcon />,
    href: "https://www.instagram.com/zikorabank",
    label: "Instagram",
  },
  {
    icon: <FacebookIcon />,
    href: "https://www.facebook.com/zikorabanks",
    label: "Facebook",
  },
];

const linkStyle = {
	fontFamily: "'Geist', sans-serif",
	fontWeight: 400,
	fontSize: "clamp(12px, 0.97vw, 14px)",
	lineHeight: "20px",
	letterSpacing: "0.02em",
	color: "#5E5E5E",
	textDecoration: "none",
	display: "block",
	wordBreak: "break-word",
	overflowWrap: "break-word",
};

const NavColumn = ({ heading, links, compactLinks = false }) => (
	<div style={{ display: "flex", flexDirection: "column", gap: "16px", flex: "1 1 0", minWidth: 0 }}>
		<span
			style={{
				fontFamily: "'Geist', sans-serif",
				fontWeight: 500,
				fontSize: "16px",
				lineHeight: "18px",
				letterSpacing: "0.08em",
				color: "#132A22",
				textTransform: "uppercase",
			}}
		>
			{heading}
		</span>
		<div style={{ display: "flex", flexDirection: "column", gap: compactLinks ? "10px" : "16px" }}>
			{links.map((link, i) => {
				if (link.to) return <RouterLink key={i} to={link.to} style={linkStyle}>{link.label}</RouterLink>;
				if (link.href) return <a key={i} href={link.href} style={linkStyle}>{link.label}</a>;
				return <span key={i} style={linkStyle}>{link.label}</span>;
			})}
		</div>
	</div>
);

const AppStoreButton = ({ icon, label }) => (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      padding: "8px",
      backgroundColor: "#000000",
      borderRadius: "8px",
      cursor: "pointer",
    }}
  >
    {icon}
    <span
      style={{
        ...inter,
        fontWeight: 600,
        fontSize: "10px",
        lineHeight: "20px",
        color: "#FFFFFF",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  </div>
);

const Footer = ({ about = false, logo = zikoraLogo }) => {
	const navColumns = about
		? NAV_COLUMNS.map((column) => {
			if (column.heading === "Products") return { ...column, links: column.links.filter((link) => ["Loans", "Z-ForHer", "Open Account", "Download App"].includes(link.label)) };
			if (column.heading === "Contact") return { ...column, links: column.links.filter((link) => link.label !== "+234 912 036 3788") };
			return column;
		})
		: NAV_COLUMNS;
	return (
		<footer className={about ? "about-footer" : undefined} style={{ width: "100%", backgroundColor: "#FFFFFF", boxSizing: "border-box", padding: "0 clamp(20px, 5.56vw, 80px)" }}>
			<style>{`
				@media (max-width: 767px) {
					.about-footer .footer-main {
						padding-top: 61px !important;
					}
					.about-footer .footer-nav-cols > div:nth-child(1) { order: 3; }
					.about-footer .footer-nav-cols > div:nth-child(2) { order: 4; }
					.about-footer .footer-nav-cols > div:nth-child(3) { order: 1; }
					.about-footer .footer-nav-cols > div:nth-child(4) { order: 2; }
					.about-footer .footer-nav-cols > div > span {
						font-size: 14px !important;
						letter-spacing: 0 !important;
						text-transform: none !important;
					}
					.about-footer .footer-bottom-bar {
						flex-direction: row !important;
						align-items: center !important;
						justify-content: space-between !important;
						flex-wrap: nowrap !important;
						gap: 8px !important;
					}
					.about-footer .footer-bottom-bar > span { font-size: 10px !important; white-space: nowrap; }
					.about-footer .footer-bottom-bar > div { gap: 4px !important; }
					.about-footer .footer-bottom-bar a { width: 24px !important; height: 24px !important; border-radius: 4px !important; }
					.about-footer .footer-bottom-bar svg { width: 14px !important; height: 14px !important; }
					.footer-main {
						flex-direction: column !important;
					}
					.footer-left {
						max-width: 100% !important;
					}
					.footer-nav-cols {
						display: grid !important;
						grid-template-columns: 1fr 1fr !important;
						gap: 32px !important;
					}
					.footer-bottom-bar {
						flex-direction: column !important;
						align-items: flex-start !important;
						gap: 24px !important;
					}
				}
				@media (max-width: 360px) {
					.about-footer .footer-bottom-bar { flex-wrap: wrap !important; }
				}
			`}</style>
			{/* Main content row */}
			<div
				className="footer-main"
				style={{
					maxWidth: "1280px",
					margin: "0 auto",
					padding: about ? "81px 0 48px" : "clamp(48px, 6.94vw, 100px) 0 clamp(32px, 3.33vw, 48px)",
					display: "flex",
					gap: "clamp(32px, 8.54vw, 123px)",
					flexWrap: "wrap",
					alignItems: "flex-start",
				}}
			>
				{/* Left: logo + tagline + store buttons */}
				<div
					className="footer-left"
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "clamp(24px, 2.78vw, 40px)",
						flex: "0 0 auto",
						maxWidth: "clamp(200px, 24.6vw, 354px)",
					}}
				>
					<RouterLink to="/">
						<img
							src={logo}
							alt="Zikora"
							style={{ width: about ? "80px" : "clamp(90px, 9.03vw, 130px)", height: "auto", display: "block" }}
						/>
					</RouterLink>

					<p
						style={{
							fontFamily: "'Geist', sans-serif",
						fontWeight: 400,
						fontSize: "clamp(13px, 1.11vw, 16px)",
						lineHeight: "1.6",
						color: "#132A22",
						margin: 0,
						}}
					>
						Banking built for the everyday people,<br />
						Ndi Anyi. Ego Anyi. Oru Anyi.
					</p>

          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            <AppStoreButton icon={<AppleIcon />} label="Get on iPhone" />
            <AppStoreButton icon={<PlayIcon />} label="Get on Android" />
          </div>
        </div>

        {/* Right: nav columns */}
        <div
          className="footer-nav-cols"
          style={{
            flex: "1 1 0",
            minWidth: 0,
            display: "flex",
            gap: "clamp(20px, 4.17vw, 60px)",
            flexWrap: "wrap",
          }}
        >
          {navColumns.map((col) => (
            <NavColumn key={col.heading} {...col} compactLinks={about} />
          ))}
        </div>
      </div>

			{/* Bottom bar */}
			<div
				style={{
					maxWidth: "1280px",
					margin: "0 auto",
					padding: "0 0 clamp(24px, 2.78vw, 40px)",
				}}
			>
				<div
					className="footer-bottom-bar"
					style={{
						borderTop: "1px solid #DEDEDE",
						paddingTop: "clamp(20px, 2.22vw, 32px)",
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						gap: "16px",
						flexWrap: "wrap",
					}}
				>
					<span
						style={{
							fontFamily: "'Geist', sans-serif",
						fontWeight: 400,
						fontSize: "clamp(12px, 0.97vw, 14px)",
						lineHeight: "18px",
						color: "#132A22",
						}}
					>
						© 2026 Zikora Bank. All rights reserved.
					</span>

					<div style={{ display: "flex", gap: "clamp(8px, 1.67vw, 24px)" }}>
						{SOCIALS.map(({ icon, href, label }) => (
							<a
								key={label}
								href={href}
								target="_blank"
								rel="noopener noreferrer"
								aria-label={label}
								style={{
									width: "44px",
									height: "44px",
									borderRadius: "8px",
									backgroundColor: "#EEEEEE",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									flexShrink: 0,
								}}
							>
								{icon}
							</a>
						))}
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
